'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortObjectKeys;

var _arrayReduce = require('fast-loops/lib/arrayReduce');

var _arrayReduce2 = _interopRequireDefault(_arrayReduce);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function sortObjectKeys(input) {
  var keys = Object.keys(input);
  var sortedKeys = keys.sort(function (a, b) {
    return a.localeCompare(b);
  });
  return (0, _arrayReduce2.default)(sortedKeys, function (output, key) {
    output[key] = input[key];
    return output;
  }, {});
}